// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
import { v4 as uuid } from 'uuid';

import type { PortalProviderAPI } from '@atlaskit/editor-common/portal';
import { getBaseNodeTypeName } from '@atlaskit/editor-common/utils/node-type-utils';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

import { unmountFromMountPoint } from './react-root-registry';
import { isFontSizeMarkActive } from './utils/validation';

export const TYPE_DROP_TARGET_DEC = 'drop-target-decoration';
export const TYPE_HANDLE_DEC = 'drag-handle';
export const TYPE_NODE_DEC = 'node-decoration';

export const NESTED_DEPTH = 100;
export const getNodeAnchor = (node: PMNode) => {
	const handleId = ObjHash.getForNode(node);
	return `--node-anchor-${node.type.name}-${handleId}`;
};

const getSubType = (node: PMNode): string => {
	if (node.attrs.level) {
		return `-${node.attrs.level}`;
	}
	if (isFontSizeMarkActive(node)) {
		return '-small';
	}
	return '';
};

export const getNodeTypeWithLevel = (node: PMNode): string => {
	const subType = expValEquals('platform_editor_small_font_size', 'isEnabled', true)
		? getSubType(node)
		: node.attrs.level
			? `-${node.attrs.level}`
			: '';

	const typeName = expValEquals('platform_editor_nest_table_in_panel', 'isEnabled', true)
		? getBaseNodeTypeName(node.type)
		: node.type.name;
	return typeName + subType;
};

class ObjHash {
	static caching = new WeakMap();

	static getForNode(node: PMNode) {
		if (this.caching.has(node)) {
			return this.caching.get(node);
		}
		// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
		const uniqueId = uuid();
		this.caching.set(node, uniqueId);
		return uniqueId;
	}
}

export const unmountDecorations = (
	nodeViewPortalProviderAPI: PortalProviderAPI,
	selector: string,
	key: string,
): void => {
	// Removing decorations manually instead of using native destroy function in prosemirror API
	// as it was more responsive and causes less re-rendering
	const decorationsToRemove = document.querySelectorAll(`[${selector}="true"]`);
	decorationsToRemove.forEach((el) => {
		unmountFromMountPoint(el);
	});
};
